import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToReportDate } from "../../../utils/dateConvert";
import { rounding } from "../../../utils/math";
import { downloadCSVFile } from "../../../api/apiClient";
import Location from '../../commoncomponents/location';
import { GetLocationAddress } from "../../../utils/mapapi";

function OverSpeedException(props) {
  let assetName= props.assetCustomerName;
  let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
  const report = props.reportDetail;

  const data = (
    <Table striped>
      <thead>
        <tr className="nowwrapTH">
          <th>No</th>
          <th>Started</th>
          <th>Type</th>
          <th>Location</th>
          <th>Completed</th>
          <th>Duration</th>
          <th>Start Speed</th>
          <th>Start Speed Limit</th>
          <th>End Speed</th>
          <th>End Speed Limit</th>
        </tr>
      </thead>
      <tbody>
        {report.map((item, index) => {
          const exceptionId = String(index + 1);
          const isSelected = String(props.selectedExceptionId) === exceptionId;
          return (
            <tr
              key={exceptionId}
              className={isSelected ? "report-row-selected" : ""}
              tabIndex={props.onExceptionSelect ? 0 : undefined}
              onClick={() => props.onExceptionSelect && props.onExceptionSelect(exceptionId)}
              onKeyDown={(event) => {
                if (props.onExceptionSelect && (event.key === "Enter" || event.key === " ")) {
                  event.preventDefault();
                  props.onExceptionSelect(exceptionId);
                }
              }}
            >
              <td>{exceptionId}</td>
              <td>{utcToReportDate(item.started)}</td>
              <td>{item.type}</td>
              <td>
                <Location
                  address={item.location}
                  lat={item.latitude}
                  lng={item.longitude}
                />
              </td>
              <td>{utcToReportDate(item.completed)}</td>
              <td>{item.duration}</td>
              <td>{rounding(item.startSpeed)}</td>
              <td>{item.startSpeedLimit}</td>
              <td>{rounding(item.endSpeed)}</td>
              <td>{item.endSpeedLimit}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );

  const ReportDetailWithlocation = async () =>{
    const updatedDetails = await Promise.all(
      props.reportDetail.map(async (item) => {
        if (item.latitude && item.longitude && !item.location
        ) {
           const location = await GetLocationAddress(item.latitude, item.longitude);
            item.location = location;
        }
        return item;
      })
  );
  return updatedDetails;
  }

  const handleDownloadExcel = async () => {
    let reportData = await ReportDetailWithlocation();
    // alert("clicked")
    downloadCSVFile(reportData,"Overspeed",assetName,timeZone);
  };
  return (
    <ToggleBar
      caption="Overspeed Exceptions"
      download={handleDownloadExcel}
      icon="fa-tachometer"
      color="#A94442"
      content={data}
    />
  );
}

export default OverSpeedException;
